import { motion } from "framer-motion";
import { DECK_OPTIONS, SPREADS } from "../data/config";
import { SectionTitle, StepShell } from "./Section";
import { Layers, ArrowLeft } from "lucide-react";

export const SpreadPicker = ({ deck, onDeck, spread, onSpread, onBack, onNext }) => {
  return (
    <StepShell>
      <button
        data-testid="spread-back-btn"
        onClick={onBack}
        className="flex items-center gap-2 text-[15px] text-[#6b4f12] hover:text-[#b8860b] mb-4 transition-colors"
      >
        <ArrowLeft size={18} /> Zurück
      </button>

      {/* Deck selection */}
      <SectionTitle kicker="Schritt 2">Wähle dein Kartensystem</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-12">
        {DECK_OPTIONS.map((d) => {
          const active = deck === d.id;
          return (
            <button
              key={d.id}
              data-testid={`deck-${d.id}`}
              onClick={() => onDeck(d.id)}
              className={`text-left rounded-2xl p-6 border transition-all duration-300 backdrop-blur-sm ${
                active
                  ? "bg-white border-[#D4AF37] glow-strong"
                  : "bg-white/70 border-[#D4AF37]/25 hover:border-[#D4AF37]/70"
              }`}
            >
              <div className="flex items-center gap-2 mb-2">
                <Layers size={20} className="text-[#B8860B]" />
                <h3 className="serif text-xl font-semibold text-[#1E3A8A]">{d.label}</h3>
              </div>
              <p className="text-[15px] leading-relaxed text-[#333]">{d.desc}</p>
            </button>
          );
        })}
      </div>

      {/* Spread selection */}
      <SectionTitle kicker="Schritt 3">Wähle deine Legung</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {SPREADS.map((s, i) => {
          const active = spread === s.id;
          return (
            <motion.button
              key={s.id}
              data-testid={`spread-${s.id}`}
              onClick={() => onSpread(s.id)}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              whileHover={{ y: -3 }}
              className={`relative text-left rounded-2xl p-5 border transition-all duration-300 backdrop-blur-sm ${
                active
                  ? "bg-white border-[#D4AF37] glow-strong"
                  : "bg-white/70 border-[#4C1D95]/15 hover:border-[#D4AF37]/60"
              }`}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="serif text-lg font-semibold text-[#4C1D95]">{s.label}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-[#333]">{s.subtitle}</p>
                </div>
                <span className="shrink-0 mt-1 inline-flex items-center justify-center min-w-9 h-9 px-2 rounded-full bg-[#FFF6DC] text-[#B8860B] text-[15px] font-semibold">
                  {s.positions.length}
                </span>
              </div>
            </motion.button>
          );
        })}
      </div>

      <div className="flex justify-center mt-10">
        <button
          data-testid="spread-next-btn"
          disabled={!spread}
          onClick={onNext}
          className={`serif text-lg px-10 py-3 rounded-full transition-all duration-300 ${
            spread
              ? "bg-gradient-to-r from-[#F0C548] to-[#B8860B] text-white glow-soft hover:glow-strong"
              : "bg-[#e9e0c8] text-[#9a9070] cursor-not-allowed"
          }`}
        >
          Weiter zu deinen Daten
        </button>
      </div>
    </StepShell>
  );
};
